<template>
    <el-button type="primary" size="small" v-bind="$attrs" v-on="$listeners"><jj-icons type="search" />
        {{ $t('buttons.search') }}
    </el-button>
</template>
<script>
export default {
    name: 'ButtonSearch'
}
</script>
